/* WGC fitment safeguards. Read-only cart matching; never changes a price or cart automatically. */
(function () {
  'use strict';
  function list(value) { return Array.isArray(value) ? value : (value ? [value] : []); }
  function norm(value) { return String(value || '').toLowerCase().replace(/[^a-z0-9]/g, ''); }
  function canonical(value) {
    var n = norm(value), aliases = {drive:'g29',g29drive:'g29',driveg29:'g29',ydre2:'drive2',precedentiq:'precedent',precedentiqexcel:'precedent',dsiq:'ds',dsiqexcel:'ds'};
    return aliases[n] || n;
  }
  function tokens(value) { return String(value || '').split(/[/,]/).map(canonical).filter(Boolean); }
  function modelMatches(values, wanted) {
    if (!wanted || /^all\b/i.test(wanted)) return false;
    var wants = tokens(wanted);
    return list(values).some(function (value) { return tokens(value).some(function (token) { return wants.indexOf(token) !== -1; }); });
  }
  function brandMatches(values, wanted) { return list(values).some(function (value) { return norm(value) === norm(wanted); }); }
  function voltageMatches(values, wanted) {
    var w = Number.parseFloat(String(wanted || ''));
    if (!Number.isFinite(w) || !list(values).length) return null;
    var known = false;
    var matched = list(values).some(function (value) {
      var s = String(value), range = s.match(/(\d+(?:\.\d+)?)\s*v?\s*(?:[-\u2013\u2014]|\bto\b)\s*(\d+(?:\.\d+)?)\s*v?\b/i);
      var nums = s.match(/\d+(?:\.\d+)?/g);
      if (!nums) return false;
      known = true;
      if (range) return w >= Math.min(Number(range[1]),Number(range[2])) && w <= Math.max(Number(range[1]),Number(range[2]));
      return nums.some(function (n) { return Math.abs(Number(n)-w) < 0.05; });
    });
    return known ? matched : null;
  }
  function powerMatches(values, wanted) {
    if (!wanted || !list(values).length) return null;
    var s = list(values).join(' ').toLowerCase();
    if (norm(wanted) === 'gas') return /\bgas\b|gasoline|petrol/.test(s);
    if (norm(wanted) === 'electric') return /electric|\b(?:ac|dc|regen|series)\b/.test(s);
    return null;
  }
  function yearMatches(range, year, model) {
    var y = Number(year);
    if (!range || !Number.isFinite(y) || !y) return null;
    var parts = String(range).split(';');
    if (parts.length > 1) {
      var names = tokens(model), selected = parts.filter(function (part) { return names.some(function (name) { return norm(part).indexOf(name) !== -1; }); });
      if (selected.length) parts = selected;
    }
    var known = false;
    var matched = parts.some(function (part) {
      var nums = part.match(/(?:19|20)\d{2}(?:\.5)?/g);
      if (!nums) { if (/all years|all model years|any year|year not restricted/i.test(part)) { known = true; return true; } return false; }
      known = true;
      var lo = Math.floor(Number(nums[0]));
      if (nums.length > 1) return y >= lo && y <= Math.floor(Number(nums[1]));
      if (/\bpre\s*[-\u2013]\s*\d|\bbefore\b/i.test(part)) return y < lo;
      if (/earlier|older|through/i.test(part)) return y <= lo;
      if (/up|newer|present|current|\+/i.test(part)) return y >= lo;
      return y === lo;
    });
    return known ? matched : null;
  }
  function isPowertrain(item) { return list(item.tags).indexOf('Powertrain Bundles') !== -1; }
  function bundleMatches(item, profile) {
    if (!profile || !profile.year || !brandMatches(item.brands,profile.brand) || !modelMatches(item.models,profile.model)) return false;
    if (yearMatches(item.years,profile.year,profile.model) === false) return false;
    if (powerMatches(item.drivetrain,profile.power) === false || voltageMatches(item.voltage,profile.voltage) === false) return false;
    if (isPowertrain(item) && (norm(profile.power) !== 'electric' || voltageMatches(item.voltage,profile.voltage) !== true)) return false;
    return true;
  }
  var engine = {list:list,norm:norm,canonical:canonical,modelsMatch:modelMatches,brandMatches:brandMatches,voltageMatches:voltageMatches,powerMatches:powerMatches,yearMatch:yearMatches,matches:bundleMatches};
  window.WgcFitmentEngine = engine;
  window.WgcBundleFitment = engine;
  function json(id) { try { var el = document.getElementById(id); return el ? JSON.parse(el.textContent) : {}; } catch (e) { return {}; } }
  function profile() { try { return JSON.parse(localStorage.getItem('wgcFitmentProfile') || sessionStorage.getItem('wgcFitmentProfile') || 'null'); } catch (e) { return null; } }
  function save(value) { ['localStorage','sessionStorage'].forEach(function (key) { try { window[key].setItem('wgcFitmentProfile',JSON.stringify(value)); } catch (e) {} }); }
  function localUrl(path) {
    var u = new URL(path,location.origin);
    if (u.origin !== location.origin) throw new Error('External fitment destination');
    var preview = new URLSearchParams(location.search).get('preview_theme_id');
    if (preview) u.searchParams.set('preview_theme_id',preview);
    return u.pathname + u.search;
  }
  function initSavedForm() {
    var f = document.getElementById('WgcCatalogFitmentForm'); if (!f || f.dataset.wgcGuard) return;
    f.dataset.wgcGuard = 'true';
    var b = document.getElementById('WgcCatalogBrand'), m = document.getElementById('WgcCatalogModel'), y = document.getElementById('WgcCatalogYear'), v = document.getElementById('WgcCatalogVoltage'), p = document.getElementById('WgcCatalogPower'), saved = profile();
    if (saved && saved.model) Array.prototype.some.call(m.options,function (option,index) { if (norm(option.text) === norm(saved.model)) { m.selectedIndex = index; return true; } return false; });
    if (/\/collections\/dc-powertrain-bundles(?:\/|$)/.test(location.pathname)) { v.required = true; p.required = true; }
    f.addEventListener('submit',function (event) {
      event.preventDefault(); event.stopImmediatePropagation();
      if (!f.reportValidity() || !b.value || !m.value || !y.value) return;
      var value = {brand:b.options[b.selectedIndex].text,model:m.options[m.selectedIndex].text,year:y.value,brandKey:b.value,modelUrl:m.value,voltage:v.value,power:p.value};
      save(value);
      var stay = /\/collections\/(?:golf-cart-bundles|dc-powertrain-bundles|lift-wheel-bundles|rear-seat-bundles|windshield-mirror-bundles|suspension-bundles)(?:\/|$)/.test(location.pathname);
      try { window.location.href = localUrl(stay ? location.pathname : m.value); } catch (e) { window.location.href = '/pages/golf-cart-fitment-help'; }
    },true);
  }
  function initProduct(config) {
    var box = document.getElementById('WgcSavedFitmentCheck'), output = box && box.querySelector('[data-wgc-fitment-result]'), saved = profile();
    if (!output || !saved) return;
    var data = json('WgcProductFitmentData'), product = config.product || {}, labels = config.labels || {}, checks = [];
    if (saved.brand) checks.push(list(data.brands).length ? brandMatches(data.brands,saved.brand) : null);
    if (saved.model) checks.push(modelMatches(data.models,saved.model));
    if (saved.year) checks.push(yearMatches(data.years,saved.year,saved.model));
    if (saved.voltage) checks.push(voltageMatches(data.voltage,saved.voltage));
    if (saved.power) checks.push(powerMatches(data.drivetrain,saved.power));
    var complete = saved.brand && saved.model && !/^all\b/i.test(saved.model) && saved.year && saved.voltage && saved.power;
    var primary = false; try { primary = /^(?:www\.)?(?:alltraxinc\.com|ddmotorsystems\.com|shop\.fsip\.biz|steelenggolfcart\.com|10l0l\.com|epochbatteries\.com|boltenergyusa\.com|ridemodz\.com|ecobattery\.com|navitasvs\.com|nivelparts\.com)$/.test(new URL(product.source).hostname); } catch (e) {}
    var verified = !product.technical && !product.wheel && complete && primary && data.verified === true && checks.length === 5 && checks.every(function (check) { return check === true; }) && !/\.5|\bunless\b|\bexcept\b/i.test(String(data.years || ''));
    box.classList.toggle('wgc-saved-fitment--match',!!verified);
    box.classList.toggle('wgc-saved-fitment--warning',!verified && !product.wheel);
    output.replaceChildren();
    var strong = document.createElement('strong'); strong.textContent = product.wheel ? labels.universal : (verified ? labels.verified : labels.check); output.appendChild(strong);
    var note = document.createElement('p'); note.textContent = labels.review; note.style.margin = '5px 0'; output.appendChild(note);
    var link = document.createElement('a'); link.textContent = labels.requirements; link.href = product.guide || '/pages/golf-cart-fitment-help'; output.appendChild(link);
    box.hidden = false;
  }
  function initACGuard(config) {
    var sel = document.getElementById('WgcPowertrainSolenoidSelect'), target = document.getElementById('WgcPowertrainTargetVoltage'), root = document.getElementById('WgcPowertrainFinder');
    if (!sel || !target || !root || root.dataset.wgcSafetyGuard) return;
    root.dataset.wgcSafetyGuard = 'true';
    var labels = config.labels || {}, catalog = json('WgcPowertrainCatalog'), forbidden = sel.querySelector('option[value="72"]'), warning = document.getElementById('WgcPowertrainSolenoidWarning');
    if (forbidden) forbidden.remove();
    var notice = document.createElement('p'); notice.className = 'wgc-powertrain-addon__warning';
    var limit = document.createElement('strong'); limit.textContent = catalog.solenoids && catalog.solenoids['72'] ? catalog.solenoids['72'].title : labels.check; notice.appendChild(limit);
    notice.appendChild(document.createTextNode(' · '));
    var guide = document.createElement('a'); guide.href = '/pages/mzj-solenoid-fitment-guide'; guide.textContent = labels.requirements; notice.appendChild(guide);
    sel.closest('.wgc-powertrain-addon__card').appendChild(notice);
    function apply() {
      var highVoltage = Number(target.value) > 60;
      sel.disabled = highVoltage;
      if (highVoltage && sel.value) { sel.value = ''; sel.dispatchEvent(new Event('change',{bubbles:true})); }
      if (highVoltage && warning) warning.textContent = limit.textContent;
    }
    target.addEventListener('change',function () { queueMicrotask(apply); });
    root.addEventListener('change',function (event) { if (event.target !== sel) queueMicrotask(apply); });
    root.addEventListener('click',function (event) { if (event.target.closest('.wgc-powertrain-add-cart')) apply(); },true);
    apply();
  }
  function init() { var config = json('WgcFitmentGuardConfig'); initSavedForm(); initProduct(config); initACGuard(config); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init); else init();
})();
